import { Navigate, useParams } from "react-router-dom";

export function InsideSalesApprovalWorkbenchPage() {
  const { approvalId } = useParams<{ approvalId: string }>();
  if (!approvalId) return <Navigate to="/inside-sales/approvals" replace />;
  return <Navigate to={`/inside-sales/approvals?ticket=${encodeURIComponent(approvalId)}`} replace />;
}
